(function () {
  // Disable view transitions on Instagram / In-App WebViews or reduced motion to prevent navigation locking
  const isMobileInAppBrowser = /Instagram|FBAN|FBAV|FB_IAB|FB4A|FBIOS|Line|Twitter|Snapchat|Pinterest|TikTok|Threads|WhatsApp|WebView|Android.*Version\/[0-9.]+/i.test(navigator.userAgent);
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isMobileInAppBrowser) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
    if (isMobileInAppBrowser) return;
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        viewTransition.skipTransition();
      }, { once: true });
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      try {
        sessionStorage.setItem('custom-transition-type', transitionType);
      } catch (_) {}
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      try {
        sessionStorage.removeItem('custom-transition-type');
      } catch (_) {}
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    let customTransitionType = null;
    try {
      customTransitionType = sessionStorage.getItem('custom-transition-type');
    } catch (_) {}

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        try {
          sessionStorage.removeItem('custom-transition-type');
        } catch (_) {}
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
  }
})();
